import React from "react";
import { useQuery } from 'react-query'
import { getResultsRSC } from "data/Querys"
import Loader from 'components/general/Loader'
import NotAvailable from "components/common/NotAvailable";
import PageHeader from "components/common/PageHeader";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import ProgressionRule from "components/common/ProgressionRule";
import GtrResults from "components/sports/gtr/views/GtrResults";
import { getLongPhaseRSC } from "helpers/rsc";

const GtrContext = () => {
    const { mirs_discipline, mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()

    //datos para el marcador y estadisticas
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['resultsData', mirs_competition, mirs_rsc, mirs_language, getLongPhaseRSC(mirs_rsc)],
            queryFn: getResultsRSC,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
            //enabled: !!confCategory
            onError: (error) =>
                console.error(`Something went wrong: ${error.message}`),
        });

    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }
    if (!data?.results) { return <NotAvailable /> }

    console.log(data)

    return (
        <>
            <PageHeader data={data} />
            <div className='mirs-page-container'>
            <ProgressionRule
                key="progress-component"
                data={data?.config}
                filter={{ type: ['QUALIFICATION'], code: ['QUAL_RULE'] }}
            />
            <div className='my-5'>
                <GtrResults data={data}/>
            </div>
            </div>
        </>
    )

}

export default GtrContext;